export default __webpack_public_path__ + "static/media/background.5f82bd2c.jpg";